
/** @format */

import React from 'react';
import { PageContainer } from 'components';
import { CommonProvider } from 'providers';
import Content from './Components/TableContent';
import {constBreadCrumbsTitle} from 'utility';
const FactorsCreditor = () => {
    
    const hint =
        'در این قسمت شما می‌توانید لیستی از فاکتورهایی که کسب‌وکارهای دیگر در سرزمین هوشمند پاد برای شما صادر کرده‌اند را مشاهده کنید و در صورت نیاز نسبت به پرداخت این فاکتورها از طریق موجودی کیف‌پول خود اقدام نمایید.';

    return (
        <PageContainer
            title="فاکتورهای خرید"
            pageKey="factorsCreditor"
            description={hint}
            breadcrumbs={constBreadCrumbsTitle.INVOICE_CREDITOR}
        >
            <CommonProvider>
                <Content />
            </CommonProvider>
        </PageContainer>
    );
};
export default FactorsCreditor;

